// extracted by mini-css-extract-plugin
export var headerCell = "_5p-1";
export var loadingSpinnerContainer = "_5p-4";
export var rowWrapper = "_5p-3";
export var standaloneTable = "_5p-5";
export var table = "_5p-0";
export var white = "_5p-2";